"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorItem = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const pixi_js_1 = require("pixi.js");
const spash_svg_1 = __importDefault(require("../../assets/svg/spash.svg"));
const spash_simple_svg_1 = __importDefault(require("../../assets/svg/spash_simple.svg"));
const Global_1 = require("../Global");
const index_1 = require("./index");
const ColorAdapter_1 = require("../config/ColorAdapter");
class ColorItem extends index_1.Block {
    constructor(app, sample, size = 0.24, simple = false) {
        super(app);
        this.size = size;
        this._enabled = true;
        this.alphaFilter = new pixi_js_1.AlphaFilter(0.6);
        this.adapter = new ColorAdapter_1.ColorAdapter(sample);
        this.inner = new pixi_js_1.Container();
        this.core = this.inner.addChild(this.adapter.makePlate());
        this.addChild(this.inner);
        this.plate = pixi_js_1.Sprite.from(simple ? spash_simple_svg_1.default : spash_svg_1.default);
        this.addChild(this.plate);
        this.splash = pixi_js_1.Sprite.from(simple ? spash_simple_svg_1.default : spash_svg_1.default);
        this.addChild(this.splash);
        this.update();
    }
    update() {
        this.plate.scale.set((0, Global_1.px)(this.size));
        if (this.core instanceof pixi_js_1.Graphics) {
            this.makeBox({
                backgroundColor: this.adapter.color,
                border: 0,
                radius: 0,
                width: this.plate.width / (0, Global_1.px)(),
                height: this.plate.height / (0, Global_1.px)()
            }, this.core);
        }
        else {
            // Assume texture
            this.core.width = this.plate.width;
            this.core.height = this.plate.height;
        }
        this.inner.mask = this.plate;
        this.splash.scale.set((0, Global_1.px)(this.size));
        this.splash.blendMode = pixi_js_1.BLEND_MODES.MULTIPLY;
        this.core.filters = [];
        if (this.adapter.isShader) {
            this.core.filters.push(this.adapter.brushShader.filter);
        }
        if (!this.enabled) {
            this.core.filters.push(this.alphaFilter);
            this.splash.alpha = this.alphaFilter.alpha;
        }
        else {
            this.splash.alpha = 1;
        }
        this.adapter.setResolution(this.width, this.height);
    }
    set enabled(is) {
        this._enabled = is;
        this.update();
    }
    get enabled() {
        return this._enabled;
    }
    destroy(_options) {
        super.destroy(_options);
        this.alphaFilter.destroy();
        this.adapter.destroy();
    }
    layout() {
        super.layout();
        this.update();
    }
}
exports.ColorItem = ColorItem;
